import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import { configData } from "../../config";

const initialState = {
  status: false,
  error: false,
  dataSetting: {},
  settingData: {},
  permissions: [],
  features: [],
  loading: false,
  getSettingStatus: false,
  settingStatus: false,
  is_thermal_print: "",
};

export const fetchSetting = createAsyncThunk(
  "setting/fetchSetting",
  async (data) => {
    console.log("token get ",data)
    try {
      var config = {
        method: "get",
        url: configData.API_URL + "setting",
        headers: {
          Authorization: `Bearer ${data.accessToken}`,
          "x-tenant": data.tenant_id,
        },
      };
      const response = await axios(config);
      const settingData = response.data.data;
      return settingData;
    } catch (err) {
      await window.log.logToFile({
        message: "Error while fetching settings",
        level: "error",
      });
      throw err;
    }
  }
);

const getSettingSlice = createSlice({
  name: "getSetting",
  initialState,
  reducers: {
    resetStatus: (state, action) => {
      state.status = false;
    },
    resetSetting: () => initialState,
    resetLoading: (state) => {
      state.loading = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSetting.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.status = true;
        state.settingStatus = true;
        if (action.payload.length > 0) {
          const settingValue = action.payload.reduce((acc, item) => {
            acc[item.key] = item.value;
            return acc;
          }, {});
          state.dataSetting = settingValue;
        }
      })

      .addCase(fetchSetting.rejected, (state, action) => {
        state.loading = false;
        state.status = false;
        state.settingStatus = false;
        state.error = `${"Unable to get settings. Please try again later."}`;
      });
  },
});
export const { resetStatus, resetSetting, resetLoading } =
  getSettingSlice.actions;
export default getSettingSlice.reducer;
